export function product(numbers: number[]) {
  if (numbers.length === 0) {
    throw new Error("Cannot calculate product of 0 numbers");
  }
  return numbers.reduce((prev, current) => prev * current, 1);
}
